import { useEffect } from "react";
import apiClient, {
  clearPersistedAuthSession,
  hasPersistedAuthSession,
  isNetworkFailure,
  markPersistedAuthSession,
  refreshAccessToken,
} from "../utils/apiClient";
import { isTokenExpired } from "../utils/tokenExpiry";

// Verifies the session (or silently refreshes) whenever token/demoRole/stable mode change.
export function useTokenVerification({
  cookies,
  token,
  setToken,
  demoRole,
  appConfig,
  setUser,
  setLoading,
}) {
  useEffect(() => {
    const verifyToken = async () => {
      // In stable mode, skip authentication and set a mock user
      if (appConfig.isStableMode) {
        setUser({
          user_id: "stable-user",
          email: "stable@demo.com",
          username: "Stable Demo User",
          role: "admin",
          status: "active",
        });
        setLoading(false);
        return;
      }

      try {
        const { data } = await apiClient.get("/api/auth/me");

        if (data.ok && data.user) {
          const user = data.user;
          user.actualRole = user.role || "user";

          // Use demo role if set, otherwise use actual role
          user.role = demoRole || user.actualRole;
          setUser(user);
          markPersistedAuthSession();
        }
      } catch (err) {
        // logout();
      } finally {
        setLoading(false);
      }
    };

    const currentToken = cookies.get("token");
    const refreshToken = cookies.get("refresh");

    if (appConfig.isStableMode) {
      verifyToken();
    } else if (currentToken && !isTokenExpired(currentToken)) {
      markPersistedAuthSession();
      if (token !== currentToken) {
        setToken(currentToken);
      }
      verifyToken();
    } else if (refreshToken && hasPersistedAuthSession()) {
      // Only use refresh when the access token is missing or already expired.
      const silentRefresh = async () => {
        setLoading(true);
        try {
          const newToken = await refreshAccessToken();
          setToken(newToken);
          // verifyToken will run again triggered by the token state change above
        } catch (err) {
          if (!isNetworkFailure(err)) clearPersistedAuthSession();
          setLoading(false);
        }
      };
      silentRefresh();
    } else {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, demoRole, appConfig.isStableMode]);
}
